import { render, staticRenderFns } from "./d-followers-list.vue?vue&type=template&id=fde1dd60&scoped=true&"
import script from "./d-followers-list.vue?vue&type=script&lang=js&"
export * from "./d-followers-list.vue?vue&type=script&lang=js&"
import style0 from "./d-followers-list.vue?vue&type=style&index=0&id=fde1dd60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde1dd60",
  null
  
)

export default component.exports